import { ICenterSummary, ICenter, ICenterSaturation, IProductOwners, IProductOwner } from "@nkr/models/index";

export const initialProductOwners: Record<string, IProductOwner> = {};

export interface ICenterState {
    summaryList: ICenterSummary[]
    list: ICenter[],
    saturationList: ICenterSaturation[],
    productOwners: Record<string, IProductOwner>,
    addAddress: boolean,
    addFollowUpLabOption: boolean
}
